import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '../../types/store';
import { getModuleData } from '../../client/selectors/modules';
import { updateModule } from '../../client/actions/modules';

export const useModuleData = (moduleId: number) => {
  const dispatch = useDispatch();
  const moduleData = useSelector((state: AppState) =>
    getModuleData(state, moduleId)
  );

  const updateModuleData = useCallback(
    (data, replace = false) =>
      dispatch(
        updateModule({
          id: moduleId,
          moduleData: replace ? data : { ...moduleData, ...data },
        })
      ),
    [dispatch, moduleId, moduleData]
  );
  return { moduleData, updateModuleData };
};

export default useModuleData;
